import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { onError } from "apollo-link-error";
import { ApolloLink } from 'apollo-link';

import { notify, returnScopeFromSeletor } from './utils/helpers'
import env from './config/environment'

const interceptor = setContext((_, { headers }) => {
  const authenticationHeaders = cbk.getHeaders()

  return {
    headers: {
      ...headers,
      ...authenticationHeaders
    }
  }
});

const errorHandler = onError(async ({ response, graphQLErrors, networkError }) => {
  let mensagem = 'Ocorreu um erro ao fazer o procedimento ou tem algum problema de conexão com o servidor';
  const $scope = returnScopeFromSeletor('#contentScreen');

  if ($scope) {
    const { EfLockScreenService, UsuariosService } = $scope.$ctrl

    if (networkError.statusCode === 403) {
      await EfLockScreenService.show(UsuariosService.usuarioLogado)
    }
  }

  notify(mensagem, 'error')
  console.log('error-apollo-client', { response, graphQLErrors, networkError })
});

const httpLink = createHttpLink({
  uri: env.graphql_url,
  credentials: 'same-origin'
});

const link = ApolloLink.from([
  interceptor,
  errorHandler,
  httpLink,
]);

const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only'
    }
  }
});

export default apolloClient
